import {
  Col,
  Checkbox,
  DatePicker,
  Input,
  InputNumber,
  Radio,
  Row,
  Select,
  Button,
  Upload,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { Controller, useWatch } from "react-hook-form";
import { Label } from "reactstrap";
import { FilePdfOutlined, UploadOutlined } from "@ant-design/icons";

// export function Text6( { id, name, control, className, logo, errors, validations }) {

//   return (
//     <Col className={`px-3 py-3 ${className && className}`} xxl={4} md={8} sm={12} xs={24}>
//       <Row className='align-items-end' style={ { height: '100%', width: '100%' } }>
//         <Label className='fs-6 text-secondary' for={id}>{name}{validations?.required && <span className='text-danger'> *</span>}</Label>
//         <Controller
//           name={id}
//           control={control}
//           render={({ field }) =>
//             <Input id={id} type='text' suffix={ logo && logo} {...field} />
//           }
//         />
//       </Row>
//     </Col>
//   )
// }

export function Text4({
  id,
  name,
  control,
  className,
  logo,
  errors,
  validations,
  disabled,
  onClick,
  onChange,
  noHtmlId,
  type,
  maxLength,
}) {
  useEffect(() => {
    if (noHtmlId) {
      document.getElementsByClassName("ant-input")[0].removeAttribute("id");
    }
  }, []);
  return (
    <Col
      className={`px-3 py-3 ${className && className}`}
      lg={6}
      sm={12}
      xs={24}
    >
      <Row
        className="align-items-end position-relative"
        style={{ height: "100%", width: "100%" }}
      >
        <Label className="fs-6 text-secondary" for={id}>
          {name}
          {validations?.required && <span className="text-danger"> *</span>}
        </Label>
        <Controller
          name={id}
          control={control}
          rules={validations}
          render={({ field }) => (
            <Input
              id={id}
              type={type ? type : "text"}
              onClick={onClick}
              suffix={logo ? logo : ""}
              onChange={(e) => (
                onChange && onChange(e.target.value),
                field.onChange(e.target.value)
              )}
              value={field?.value}
              placeholder={`Enter ${name} here...`}
              disabled={disabled}
              maxLength={maxLength}
            />
          )}
        />

        {errors && errors[id]?.type === "required" && (
          <span
            className="position-absolute top-100 text-danger"
            style={{ fontSize: "13px", bottom: "-20px" }}
            role="alert"
          >
            {name} is required
          </span>
        )}

        {errors && errors[id]?.type === "pattern" && (
          <span
            className="position-absolute top-100 text-danger"
            style={{ fontSize: "13px", bottom: "-20px" }}
            role="alert"
          >
            {errors[id]?.message || "Field is invalid"}
          </span>
        )}
        {errors && errors[id]?.type === "minLength" && (
          <span
            className="position-absolute top-100 text-danger"
            style={{ fontSize: "13px", bottom: "-20px" }}
            role="alert"
          >
            More than {validations.minLength} letters required
          </span>
        )}
        {errors && errors[id]?.type === "maxLength" && (
          <span
            className="position-absolute top-100 text-danger"
            style={{ fontSize: "13px", bottom: "-20px" }}
            role="alert"
          >
            Less than {validations.maxLength} letters required
          </span>
        )}
        {/* {errors && errors[id]?.type === "pattern" && (
          <span
            className="position-absolute top-100 text-danger"
            style={{ fontSize: "13px", bottom: "-20px" }}
            role="alert"
          >
            Field is Invalid
          </span>
        )} */}
      </Row>
    </Col>
  );
}

// export function Text3( { id, name, control, className, logo, errors, validations }) {

//   return (
//     <Col className={`px-3 py-3 ${className && className}`} md={8} sm={12} xs={24}>
//       <Row className='align-items-end' style={ { height: '100%', width: '100%' } }>
//         <Label className='fs-6 text-secondary' for={id}>{name}{validations?.required && <span className='text-danger'> *</span>}</Label>
//         <Controller
//           name={id}
//           control={control}
//           render={({ field }) =>
//             <Input id={id} type='text' suffix={ logo && logo} {...field} />
//           }
//         />
//       </Row>
//     </Col>
//   )
// }

export function Text2({
  id,
  name,
  control,
  className,
  logo,
  errors,
  validations,
  disabled,
  onClick,
  onChange,
  noHtmlId,
  type,
  maxLength,
}) {
  useEffect(() => {
    if (noHtmlId) {
      document.getElementsByClassName("ant-input")[0].removeAttribute("id");
    }
  }, []);
  return (
    <Col className={`px-3 py-3 ${className && className}`} sm={12} xs={24}>
      <Row
        className="align-items-end position-relative"
        style={{ height: "100%", width: "100%" }}
      >
        <Label className="fs-6 text-secondary" for={id}>
          {name}
          {validations?.required && <span className="text-danger"> *</span>}
        </Label>
        <Controller
          name={id}
          control={control}
          rules={validations}
          render={({ field }) => (
            <Input
              id={id}
              type={type ? type : "text"}
              onClick={onClick}
              suffix={logo ? logo : ""}
              onChange={(e) => (
                onChange && onChange(e.target.value),
                field.onChange(e.target.value)
              )}
              value={field.value}
              placeholder={`Enter ${name} here...`}
              disabled={disabled}
              maxLength={maxLength}
            />
          )}
        />
        {errors && errors[id]?.type === "required" && (
          <span
            className="position-absolute top-100 text-danger"
            style={{ fontSize: "13px", bottom: "-20px" }}
            role="alert"
          >
            {name} is required
          </span>
        )}
        {errors && errors[id]?.type === "minLength" && (
          <span
            className="position-absolute top-100 text-danger"
            style={{ fontSize: "13px", bottom: "-20px" }}
            role="alert"
          >
            More than {validations.minLength} letters required
          </span>
        )}
        {errors && errors[id]?.type === "maxLength" && (
          <span
            className="position-absolute top-100 text-danger"
            style={{ fontSize: "13px", bottom: "-20px" }}
            role="alert"
          >
            Less than {validations.maxLength} letters required
          </span>
        )}
        {errors && errors[id]?.type === "pattern" && (
          <span
            className="position-absolute top-100 text-danger"
            style={{ fontSize: "13px", bottom: "-20px" }}
            role="alert"
          >
            Field is Invalid
          </span>
        )}
      </Row>
    </Col>
  );
}

export function Text1({
  id,
  name,
  control,
  className,
  logo,
  errors,
  validations,
  disabled,
  onClick,
  onChange,
  noHtmlId,
  type,
}) {
  useEffect(() => {
    if (noHtmlId) {
      document.getElementsByClassName("ant-input")[0].removeAttribute("id");
    }
  }, []);
  return (
    <Col className={`px-3 py-3 ${className && className}`} sm={24} xs={24}>
      <Row
        className="align-items-end position-relative"
        style={{ height: "100%", width: "100%" }}
      >
        <Label className="fs-6 text-secondary" for={id}>
          {name}
          {validations?.required && <span className="text-danger"> *</span>}
        </Label>
        <Controller
          name={id}
          control={control}
          rules={validations}
          render={({ field }) => (
            <Input
              id={id}
              type={type ? type : "text"}
              onClick={onClick}
              suffix={logo ? logo : ""}
              onChange={(e) => (
                onChange(e.target.value), field.onChange(e.target.value)
              )}
              value={field.value}
              placeholder={`Enter ${name} here...`}
              disabled={disabled}
            />
          )}
        />
        {errors && errors[id]?.type === "required" && (
          <span
            className="position-absolute top-100 text-danger"
            style={{ fontSize: "13px", bottom: "-20px" }}
            role="alert"
          >
            {name} is required
          </span>
        )}
        {errors && errors[id]?.type === "minLength" && (
          <span
            className="position-absolute top-100 text-danger"
            style={{ fontSize: "13px", bottom: "-20px" }}
            role="alert"
          >
            More than {validations.minLength} letters required
          </span>
        )}
        {errors && errors[id]?.type === "maxLength" && (
          <span
            className="position-absolute top-100 text-danger"
            style={{ fontSize: "13px", bottom: "-20px" }}
            role="alert"
          >
            Less than {validations.maxLength} letters required
          </span>
        )}
      </Row>
    </Col>
  );
}

export function TextArea1({
  id,
  name,
  control,
  className,
  logo,
  errors,
  validations,
  disabled,
  onClick,
  onChange,
  noHtmlId,
}) {
  useEffect(() => {
    if (noHtmlId) {
      document.getElementsByClassName("ant-input")[0].removeAttribute("id");
    }
  }, []);
  return (
    <Col className={`px-3 py-3 ${className && className}`} sm={24} xs={24}>
      <Row
        className="align-items-end position-relative"
        style={{ height: "100%", width: "100%" }}
      >
        <Label className="fs-6 text-secondary" for={id}>
          {name}
          {validations?.required && <span className="text-danger"> *</span>}
        </Label>
        <Controller
          name={id}
          control={control}
          rules={validations}
          render={({ field }) => (
            <TextArea
              rows={4}
              id={id}
              onClick={onClick}
              suffix={logo ? logo : ""}
              onChange={(e) => {
                onChange && onChange(e.target.value);
                field.onChange(e.target.value);
              }}
              value={field.value}
              placeholder={`Enter ${name} here...`}
              disabled={disabled}
            />
          )}
        />
        {errors && errors[id]?.type === "required" && (
          <span
            className="position-absolute top-100 text-danger"
            style={{ fontSize: "13px", bottom: "-20px" }}
            role="alert"
          >
            {name} is required
          </span>
        )}
        {errors && errors[id]?.type === "minLength" && (
          <span
            className="position-absolute top-100 text-danger"
            style={{ fontSize: "13px", bottom: "-20px" }}
            role="alert"
          >
            More than {validations.minLength} letters required
          </span>
        )}
        {errors && errors[id]?.type === "maxLength" && (
          <span
            className="position-absolute top-100 text-danger"
            style={{ fontSize: "13px", bottom: "-20px" }}
            role="alert"
          >
            Less than {validations.maxLength} letters required
          </span>
        )}
      </Row>
    </Col>
  );
}

export function Select4({
  id,
  name,
  control,
  className,
  options,
  errors,
  validations,
  disabled,
  onChange,
}) {
  return (
    <Col
      className={`px-3 py-3 ${className && className}`}
      lg={6}
      sm={12}
      xs={24}
    >
      <Row
        className="align-items-end position-relative"
        style={{ height: "100%", width: "100%" }}
      >
        <Label className="fs-6 text-secondary" for={id}>
          {name}
          {validations?.required && <span className="text-danger"> *</span>}
        </Label>
        <Controller
          name={id}
          control={control}
          rules={validations}
          render={({ field }) => (
            <Select
              style={{ width: "100%" }}
              id={id}
              placeholder={`Select ${name} here...`}
              options={options}
              disabled={disabled}
              value={field.value}
              onChange={(val) => {
                field.onChange(val);
                onChange && onChange(val);
              }}
            />
          )}
        />
        {errors && errors[id]?.type === "required" && (
          <span
            className="position-absolute top-100 text-danger"
            style={{ fontSize: "13px", bottom: "-20px" }}
            role="alert"
          >
            {name} is required
          </span>
        )}
      </Row>
    </Col>
  );
}

export function Select2({
  id,
  name,
  control,
  className,
  defaultopt,
  options,
  errors,
  validations,
  disabled,
  onChange,
}) {
  return (
    <Col className={`px-3 py-3 ${className && className}`} sm={12} xs={24}>
      <Row
        className="align-items-end position-relative"
        style={{ height: "100%", width: "100%" }}
      >
        <Label className="fs-6 text-secondary" for={id}>
          {name}
          {validations?.required && <span className="text-danger"> *</span>}
        </Label>
        <Controller
          name={id}
          control={control}
          rules={validations}
          render={({ field }) => (
            <Select
              defaultValue={defaultopt}
              style={{ width: "100%" }}
              id={id}
              allowClear
              showSearch
              placeholder={`Select ${name} here...`}
              options={options}
              disabled={disabled}
              value={field.value}
              onChange={(val) => {
                field.onChange(val);
                onChange && onChange(val);
              }}
            />
          )}
        />
        {errors && errors[id]?.type === "required" && (
          <span
            className="position-absolute top-100 text-danger"
            style={{ fontSize: "13px", bottom: "-20px" }}
            role="alert"
          >
            {name} is required
          </span>
        )}
      </Row>
    </Col>
  );
}
export function SelectMultiple({
  id,
  name,
  control,
  className,
  options,
  errors,
  validations,
  onChange,
}) {
  return (
    <Col className={`px-3 py-3 ${className && className}`} sm={24} xs={24}>
      <Row
        className="align-items-end position-relative"
        style={{ height: "100%", width: "100%" }}
      >
        <Label className="fs-6 text-secondary" for={id}>
          {name}
          {validations?.required && <span className="text-danger"> *</span>}
        </Label>
        <Controller
          name={id}
          control={control}
          rules={validations}
          render={({ field }) => (
            <Select
              mode="multiple"
              allowClear
              style={{ width: "100%" }}
              id={id}
              placeholder={`Select ${name} here...`}
              options={options}
              onChange={(val) => {
                field.onChange(val);
                onChange && onChange(val);
              }}
              {...field}
            />
          )}
        />
        {errors && errors[id]?.type === "required" && (
          <span
            className="position-absolute top-100 text-danger"
            style={{ fontSize: "13px", bottom: "-20px" }}
            role="alert"
          >
            {name} is required
          </span>
        )}
      </Row>
    </Col>
  );
}

export function Select1({
  id,
  name,
  control,
  className,
  options,
  errors,
  validations,
}) {
  return (
    <Col className={`px-3 py-3 ${className && className}`} sm={24} xs={24}>
      <Row
        className="align-items-end position-relative"
        style={{ height: "100%", width: "100%" }}
      >
        <Label className="fs-6 text-secondary" for={id}>
          {name}
          {validations?.required && <span className="text-danger"> *</span>}
        </Label>
        <Controller
          name={id}
          control={control}
          rules={validations}
          render={({ field }) => (
            <Select
              style={{ width: "100%" }}
              id={id}
              placeholder={`Select ${name} here...`}
              options={options}
              {...field}
            />
          )}
        />
        {errors && errors[id]?.type === "required" && (
          <span
            className="position-absolute top-100 text-danger"
            style={{ fontSize: "13px", bottom: "-20px" }}
            role="alert"
          >
            {name} is required
          </span>
        )}
      </Row>
    </Col>
  );
}

export function Radio2({
  id,
  name,
  control,
  className,
  errors,
  validations,
  disabled,
  options,
}) {
  return (
    <Col className={`px-3 py-3 ${className && className}`} sm={12} xs={24}>
      <Row
        className="align-items-end position-relative"
        style={{ height: "100%", width: "100%" }}
      >
        <Label className="fs-6 text-secondary" for={id}>
          {name}
          {validations?.required && <span className="text-danger"> *</span>}
        </Label>
        <Controller
          name={id}
          control={control}
          rules={validations}
          render={({ field }) => (
            <Radio.Group
              {...field}
              disabled={disabled}
              style={{ width: "100%" }}
              options={options}
              optionType="button"
              buttonStyle="outline"
            />
          )}
        />
        {errors && errors[id]?.type === "required" && (
          <span
            className="position-absolute top-100 text-danger"
            style={{ fontSize: "13px", bottom: "-20px" }}
            role="alert"
          >
            {name} is required
          </span>
        )}
        {errors && errors[id]?.type === "minLength" && (
          <span
            className="position-absolute top-100 text-danger"
            style={{ fontSize: "13px", bottom: "-20px" }}
            role="alert"
          >
            More than {validations.minLength} letters required
          </span>
        )}
        {errors && errors[id]?.type === "maxLength" && (
          <span
            className="position-absolute top-100 text-danger"
            style={{ fontSize: "13px", bottom: "-20px" }}
            role="alert"
          >
            Less than {validations.maxLength} letters required
          </span>
        )}
      </Row>
    </Col>
  );
}

export function Date4({
  id,
  name,
  control,
  className,
  errors,
  validations,
  disabled,
}) {
  return (
    <Col
      className={`px-3 py-3 ${className && className}`}
      lg={6}
      sm={12}
      xs={24}
    >
      <Row
        className="align-items-end position-relative"
        style={{ height: "100%", width: "100%" }}
      >
        <Label className="fs-6 text-secondary" for={id}>
          {name}
          {validations?.required && <span className="text-danger"> *</span>}
        </Label>
        <Controller
          name={id}
          control={control}
          rules={validations}
          defaultValue=""
          render={({ field }) => (
            <DatePicker
              style={{ width: "100%" }}
              format="YYYY-MM-DD"
              allowClear
              inputReadOnly={false}
              id={id}
              placeholder={`Select ${name} here...`}
              value={
                field.value === "" ? null : dayjs(field.value, "YYYY-MM-DD")
              }
              onChange={(dayjs, str) => {
                field.onChange(str);
              }}
              disabled={disabled}
            />
          )}
        />
        {errors && errors[id]?.type === "required" && (
          <span
            className="position-absolute top-100 text-danger"
            style={{ fontSize: "13px", bottom: "-20px" }}
            role="alert"
          >
            {name} is required
          </span>
        )}
      </Row>
    </Col>
  );
}

export function Date2({
  id,
  name,
  control,
  className,
  errors,
  validations,
  disabled,
}) {
  return (
    <Col className={`px-3 py-3 ${className && className}`} sm={12} xs={24}>
      <Row
        className="align-items-end position-relative"
        style={{ height: "100%", width: "100%" }}
      >
        <Label className="fs-6 text-secondary" for={id}>
          {name}
          {validations?.required && <span className="text-danger"> *</span>}
        </Label>
        <Controller
          name={id}
          control={control}
          rules={validations}
          defaultValue=""
          render={({ field }) => (
            <DatePicker
              style={{ width: "100%" }}
              id={id}
              placeholder={`Select ${name} here...`}
              value={
                field.value === "" ? null : dayjs(field.value, "YYYY-MM-DD")
              }
              onChange={(dayjs, str) => {
                field.onChange(str);
              }}
              disabled={disabled}
            />
          )}
        />
        {errors && errors[id]?.type === "required" && (
          <span
            className="position-absolute top-100 text-danger"
            style={{ fontSize: "13px", bottom: "-20px" }}
            role="alert"
          >
            {name} is required
          </span>
        )}
      </Row>
    </Col>
  );
}

export function DateRange4({
  id,
  name,
  control,
  className,
  errors,
  validations,
}) {
  const { RangePicker } = DatePicker;
  return (
    <Col
      className={`px-3 py-3 ${className && className}`}
      lg={6}
      sm={12}
      xs={24}
    >
      <Row
        className="align-items-end position-relative"
        style={{ height: "100%", width: "100%" }}
      >
        <Label className="fs-6 text-secondary" for={id}>
          {name}
          {validations?.required && <span className="text-danger"> *</span>}
        </Label>
        <Controller
          name={id}
          control={control}
          rules={validations}
          render={({ field }) => (
            <RangePicker style={{ width: "100%" }} id={id} {...field} />
          )}
        />
        {errors && errors[id]?.type === "required" && (
          <span
            className="position-absolute top-100 text-danger"
            style={{ fontSize: "13px", bottom: "-20px" }}
            role="alert"
          >
            {name} is required
          </span>
        )}
      </Row>
    </Col>
  );
}

export function Number4({
  id,
  name,
  control,
  className,
  errors,
  validations,
  prefix,
  suffix,
}) {
  return (
    <Col
      className={`px-3 py-3 ${className && className}`}
      lg={6}
      sm={12}
      xs={24}
    >
      <Row
        className="align-items-end position-relative"
        style={{ height: "100%", width: "100%" }}
      >
        <Label className="fs-6 text-secondary" for={id}>
          {name}
          {validations?.required && <span className="text-danger"> *</span>}
        </Label>
        <Controller
          name={id}
          control={control}
          rules={validations}
          render={({ field }) => (
            <InputNumber
              style={{ width: "100%" }}
              addonAfter={suffix}
              addonBefore={prefix}
              id={id}
              {...field}
              placeholder={`Enter ${name} here...`}
            />
          )}
        />
        {errors && errors[id]?.type === "required" && (
          <span
            className="position-absolute top-100 text-danger"
            style={{ fontSize: "13px", bottom: "-20px" }}
            role="alert"
          >
            {name} is required
          </span>
        )}
      </Row>
    </Col>
  );
}

export function Checkbox1({
  id,
  name,
  control,
  className,
  onChange,
  disabled,
  defaultChecked,
}) {
  return (
    <Col className={`px-3 py-3 ${className && className}`} sm={16} xs={24}>
      <Row
        className="align-items-end position-relative"
        style={{ height: "100%", width: "100%" }}
      >
        <Controller
          name={id}
          control={control}
          render={({ field }) => (
            <Checkbox
              checked={defaultChecked}
              onChange={(val) => {
                field.onChange(val);
                onChange && onChange(val);
              }}
              style={{ marginRight: "5px", marginBottom: "10px" }}
              id={id}
            />
          )}
        />
        <Label className="fs-6 text-secondary" for={id}>
          {name}
        </Label>
      </Row>
    </Col>
  );
}

export function UploadField({
  id,
  name,
  control,
  validations,
  errors,
  className,
  disabled,
}) {
  const [fileUrl, setFileUrl] = useState("");
  const [isImage, setIsImage] = useState(false);
  const [fileName, setFileName] = useState("View Document");

  // Watch the value of this field using react-hook-form's useWatch
  const watchedValue = useWatch({
    control,
    name: id,
  });

  // Update preview when watchedValue changes
  useEffect(() => {
    let urlToRevoke = null;

    if (!watchedValue) {
      setFileUrl("");
      setIsImage(false);
      setFileName("View Document");
      return;
    }

    let file = Array.isArray(watchedValue) ? watchedValue[0] : watchedValue;

    if (file instanceof File) {
      urlToRevoke = URL.createObjectURL(file);
      setFileUrl(urlToRevoke);
      setIsImage(file.type.startsWith("image/"));
      setFileName(file.name);
    } else if (typeof file === "string") {
      setFileUrl(file);
      setIsImage(/\.(jpe?g|png|gif|webp)$/i.test(file));
      setFileName("View Document");
    } else if (file && typeof file === "object" && file.url) {
      setFileUrl(file.url);
      setIsImage(/\.(jpe?g|png|gif|webp)$/i.test(file.url));
      setFileName("View Document");
    } else {
      setFileUrl("");
      setIsImage(false);
      setFileName("View Document");
    }

    return () => {
      if (urlToRevoke) URL.revokeObjectURL(urlToRevoke);
    };
  }, [watchedValue]);

  return (
    <Col className={`px-3 py-2 ${className || ""}`} lg={8} sm={12} xs={24}>
      <div className="w-full">
        <Label className="fs-6 text-secondary block mb-2" htmlFor={id}>
          {name}
          {validations?.required && <span className="text-danger"> *</span>}
        </Label>

        <Controller
          name={id}
          control={control}
          rules={validations}
          render={({ field }) => (
            <div>
              {/* Show link for non-image */}
              {fileUrl && !isImage && (
                <div className="mb-2">
                  <a
                    href={fileUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-blue-600 underline"
                  >
                    View Document
                  </a>
                </div>
              )}

              <Upload
                beforeUpload={(file) => {
                  field.onChange(file);
                  return false; // prevent auto upload
                }}
                maxCount={1}
                disabled={disabled}
                fileList={[]} // manual control
                onRemove={() => field.onChange(null)}
                showUploadList={false}
              >
                {fileUrl ? (
                  isImage ? (
                    <div className="relative group w-[220px] h-[120px] rounded-lg overflow-hidden border border-dashed border-gray-300 cursor-pointer">
                      <img
                        src={fileUrl}
                        alt="preview"
                        className="w-full h-full object-cover"
                      />
                      <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center text-white opacity-0 group-hover:opacity-100 transition">
                        <span className="text-sm">Change</span>
                      </div>
                    </div>
                  ) : (
                    <div className="w-[220px] h-[120px] bg-gray-100 rounded-lg border border-dashed border-gray-300 flex items-center justify-center cursor-pointer hover:border-blue-400 transition">
                      <UploadOutlined className="text-2xl text-gray-500" />
                      <span className="ml-2 text-gray-600">
                        Click to Upload
                      </span>
                    </div>
                  )
                ) : (
                  <div className="w-[220px] h-[120px] bg-gray-100 rounded-lg border border-dashed border-gray-300 flex flex-col items-center justify-center cursor-pointer hover:border-blue-400 transition">
                    <UploadOutlined className="text-2xl text-gray-500 mb-1" />
                    <span className="text-sm text-gray-600">Upload</span>
                  </div>
                )}
              </Upload>
            </div>
          )}
        />

        {errors?.[id] && (
          <span className="text-danger text-xs block mt-1">
            {errors[id]?.message || `${name} is required`}
          </span>
        )}
      </div>
    </Col>
  );
}
